var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "b-form",
        {
          class: [_vm.inline ? "gap-2 items-center" : ""],
          attrs: { inline: _vm.inline },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
            reset: [
              function($event) {
                $event.preventDefault()
                return _vm.clear($event)
              },
              _vm.onReset
            ]
          }
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-1",
                label: _vm.$t("knowledge_item_title"),
                "label-for": "knowledge_item_title"
              }
            },
            [
              _c("b-form-input", {
                staticClass: "required",
                attrs: {
                  id: "knowledge_item_title",
                  placeholder: _vm.$t("knowledge_item_subject"),
                  disabled: ""
                },
                model: {
                  value: _vm.item.title,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "title", $$v)
                  },
                  expression: "item.title"
                }
              })
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-3",
                label: _vm.$t("knowledge_item_category"),
                "label-for": "knowledge_item_category"
              }
            },
            [
              _c("b-form-select", {
                staticClass: "required-select",
                attrs: {
                  id: "knowledge-item-category",
                  options: _vm.knowledgeCategories,
                  "text-field": "name",
                  "value-field": "id",
                  disabled: ""
                },
                model: {
                  value: _vm.item.knowledge_category_id,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "knowledge_category_id", $$v)
                  },
                  expression: "item.knowledge_category_id"
                }
              })
            ],
            1
          ),
          _vm.item.description
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-2",
                    label: _vm.$t("knowledge_item_description"),
                    "label-for": "knowledge_item_description"
                  }
                },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "html-safe",
                        rawName: "v-html-safe",
                        value: _vm.item.description,
                        expression: "item.description"
                      }
                    ],
                    staticClass:
                      "simple-content simple-editor simple-editor-disabled"
                  })
                ]
              )
            : _vm._e(),
          _c(
            "b-row",
            { staticClass: "m-0" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c("h5", { staticClass: "mt-2 mb-0" }, [
                    _vm._v(_vm._s(_vm.$t("knowledge_subtitle_document")))
                  ]),
                  _c("vs-divider")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "pt-2" },
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("media-list", {
                    attrs: {
                      medias: _vm.files,
                      "show-delete": false,
                      "action-on-click": false
                    }
                  }),
                  !_vm.files || _vm.files.length == 0
                    ? _c(
                        "div",
                        { staticClass: "flex flex-row justify-center" },
                        [_vm._v(" " + _vm._s(_vm.$t("msg_none_file")) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }